// =====================================================
// WeLearn Pro Player - Slide module
// =====================================================

export default class Slide {
    constructor(player) {
        this.player = player;
    }

    /**
     * Check initialized sync state to determine if the plugin should sync or unsync slide
     */
    checkSyncState() {
        return this.player.options.syncSlide ? this.syncSlide() : this.unsyncSlide();
    }

    /**
     * Sync slide
     * @returns {boolean} - Sync state
     */
    syncSlide() {
        $('.carousel-control-next').css({ 'pointer-events': 'none', 'display': 'none' });
        $('.carousel-control-prev').css({ 'pointer-events': 'none', 'display': 'none' });

        $('.wlpVideo__sync').css({ color: '#10d000' });
        return true;
    }

    /**
     * Unsync slide
     * @returns {boolean} - Unsync state
     */
    unsyncSlide() {
        $('.carousel-control-next').css({ 'pointer-events': 'auto', 'display': 'flex' });
        $('.carousel-control-prev').css({ 'pointer-events': 'auto', 'display': 'flex' });
        $('.wlpVideo__sync').css({ color: '#ffffff' });
        return false;
    }

    /**
     * Change slide page to specify page.
     * @param slidePage - Slide page to change to.
     */
    changeSlidePage(slidePage) {
        let fancybox = $.fancybox.getInstance();
        $('#wlpVideo_slide').carousel(slidePage);

        if (fancybox) {
            fancybox.jumpTo(slidePage);
        }
    }
}